@if (chips().length > 0) {
  <div
    class="tf-attachments-row"
    role="list"
    [attr.aria-label]="'COMMENTS.ATTACHMENT.LIST_ARIA' | translate">
    @for (chip of chips(); track chip.filestoreFileId) {
      <span role="listitem">
        <tf-attachment-chip
          [attachment]="chip"
          (attachmentClick)="attachmentClick.emit($event)" />
      </span>
    }
  </div>
}
